module.exports = __webpack_public_path__ + "assets/img/baoche3.534eaeef.png";